/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum Countries {
  austria = 'austria',
  estonia = 'estonia',
  switzerland = 'switzerland',
  south_africa = 'south_africa',
  uruguay = 'uruguay',
}
